import React from 'react';
export function Footer() {
  return <footer className="bg-black py-8 border-t border-dark-border text-center px-4" data-id="element-123" data-mp="32wd2qgad7ltj">
      <div className="max-w-4xl mx-auto" data-id="element-124" data-mp="3gg0za3iktxxn">
        <p className="text-gold-dark text-sm" data-id="element-125" data-mp="3gh3ng3oilm9v">
          © {new Date().getFullYear()} Metodologia della Ricerca Pro — Tutti i
          diritti riservati.
        </p>
      </div>
    </footer>;
}